"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paypalReusePaymentMethod = exports.paypalApproveOrder = exports.paypalCreateOrder = void 0;
const utils_1 = require("./utils");
const paypalEndpoint = `${utils_1.endpoint}/paypal`;
const paypalCreateOrderEndpoint = `${paypalEndpoint}/orders`;
const paypalApproveEndpoint = (id) => `${paypalCreateOrderEndpoint}/${id}/approve`;
const paypalReusePaymentMethodEndpoint = `${paypalCreateOrderEndpoint}/paymentMethod`;
const request = async (request, payload) => {
    let body;
    try {
        body = payload ? JSON.stringify(payload) : undefined;
    }
    catch (e) {
        throw new Error('Can not serialize the payload');
    }
    const isNetworkError = (error) => {
        // Rethrow only if it's a server error 500/502/503
        return error.message.includes('HTTP error 5');
    };
    const isClientError = (error) => {
        return error.message.startsWith('HTTP error 4');
    };
    try {
        const res = await fetch(request.endpoint, {
            method: request.method,
            body,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });
        const result = await res.json();
        // Promise resolved but return status is 2xx
        if (res.ok)
            return result;
        // Promise resolved but return status is not 2xx
        const errorMessage = `HTTP error ${res.status}: ${result.message || res.statusText}${result.code ? ` (${result.code})` : ''}`;
        throw new Error(errorMessage);
    }
    catch (e) {
        console.error('Error in request', e);
        if (e instanceof TypeError || e.message.includes('Failed to fetch'))
            throw new Error('Network error: ' + e.message);
        if (isNetworkError(e)) {
            const errMessage = e.message.replace(/^HTTP error \d+\:/g, 'Error:');
            throw new Error(errMessage);
        }
        else if (isClientError(e)) {
            const errMessage = e.message.replace(/^HTTP error \d+\: /g, '');
            throw new Error(`There was a problem with your request. Please check your data and try again. ${errMessage}`);
        }
        throw e;
    }
};
async function paypalCreateOrder(data) {
    return await request({
        endpoint: paypalCreateOrderEndpoint,
        method: "POST"
    }, data);
}
exports.paypalCreateOrder = paypalCreateOrder;
async function paypalApproveOrder(orderID, data) {
    return await request({
        endpoint: paypalApproveEndpoint(orderID),
        method: "POST"
    }, data);
}
exports.paypalApproveOrder = paypalApproveOrder;
async function paypalReusePaymentMethod(data) {
    return await request({
        endpoint: paypalReusePaymentMethodEndpoint,
        method: "POST"
    }, data);
}
exports.paypalReusePaymentMethod = paypalReusePaymentMethod;
